import React from "react";
import { createRoot } from "react-dom/client";
import reportWebVitals from "./reportWebVitals";

// import ReactDOM from 'react-dom';
import "./index.css";
import "./config/Styles"; // Importa Styles.tsx que inclui PrimeReact e tokens.css
// import './config/Scripts';
import './utilities/i18n';

import App from "./App";
import { ThemeProvider } from "./theme";

reportWebVitals();

const root = createRoot(document.getElementById("root") as HTMLDivElement);
if (root === null) throw new Error("Root container missing in index.html");

root.render(
  <React.Suspense fallback="">
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.Suspense>,
);
